import React, { Component } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import DownloadImgModalView from "presentational/common/modals/DownloadImgModalView";
import clipboardCopy from "lib/clipboardCopy";
import CopyLinkTextView from "presentational/common/CopyLinkTextView";
import TXT from "presentational/common/multinational/TXT";
import { withStore } from "store/storeHandler";
import config from "lib/fr-config";
import { getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

const colorCss = config.css.color;

const SHORTCUT_ROOT_URL = config.shortcutRootURL;

class OptBtnForMyOutfitModalView extends Component {
  static propTypes = {
    outfitHash: PropTypes.string.isRequired,
    optionModalOpen: PropTypes.bool.isRequired,
    onEditModeSelect: PropTypes.func.isRequired,
    isEditModeEnabled: PropTypes.bool.isRequired,
    outfitImgUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    username: PropTypes.string.isRequired,
    itemData: PropTypes.array,
    calendarData: PropTypes.object
  };

  state = {
    deleteModalOpen: false,

    downloadModalOpen: false,
    downloadImgInfoObj: {}
  };

  getShortcutOutfitUrl() {
    const { outfitHash } = this.props;
    return `${SHORTCUT_ROOT_URL}${getEssentialUrl({ type: "shortcutOutfit" })(
      outfitHash
    )}`;
  }

  handleModalClose = () => {
    this.setState({ deleteModalOpen: false, downloadModalOpen: false });
  };

  handleDeleteSelect = () => {
    const { onClose } = this.props;
    onClose();
    this.setState({ deleteModalOpen: true });
  };

  handleLinkCopyClick = () => {
    const { onClose, NoticeModalActions } = this.props;
    onClose();

    const shourcutUrl = this.getShortcutOutfitUrl();
    clipboardCopy(shourcutUrl);
    NoticeModalActions.openModal({
      content: <CopyLinkTextView />
    });
  };

  handleDownloadListBtnClick = async () => {
    const { onClose, outfitImgUrl, username, itemData, calendarData } =
      this.props;
    const { date } = calendarData;

    this.setState({
      downloadModalOpen: true,
      downloadImgInfoObj: {
        downloadImgType: "brand",
        imageSrc: outfitImgUrl,
        date,
        username,
        itemData
      }
    });

    onClose();
  };

  handleOutfitDelete = () => {
    const { onDeleteClick } = this.props;
    this.setState({ deleteModalOpen: false });
    onDeleteClick();
  };

  handleEditSelect = () => {
    const { onEditModeSelect, isEditModeEnabled, onClose } = this.props;
    if (!isEditModeEnabled) return null;
    onClose();
    onEditModeSelect();
  };

  render() {
    const { optionModalOpen, onClose } = this.props;
    const { deleteModalOpen, downloadModalOpen, downloadImgInfoObj } =
      this.state;

    return (
      <div>
        <CommonModalView
          open={optionModalOpen}
          onClose={onClose}
          buttonList={[
            {
              primary: <TXT name="btnList_copyLink" />,
              secondary: <TXT name="msg_copyLinkShareMsgWithoutFunc" />,
              func: this.handleLinkCopyClick
            },
            {
              primary: <TXT name="btnList_downloadImage" />,
              secondary: null,
              func: this.handleDownloadListBtnClick
            },
            {
              primary: <TXT name="btnList_editOutfit" />,
              secondary: null,
              func: this.handleEditSelect
            },
            {
              primary: <TXT name="btnList_deleteOutfit" />,
              secondary: null,
              func: this.handleDeleteSelect
            }
          ]}
          firstButtonText={<TXT name="btnModal_close" />}
          firstButtonFunc={onClose}
        />
        <CommonModalView
          open={deleteModalOpen}
          onClose={this.handleModalClose}
          titleText={<TXT name="titleModal_deleteOutfit" />}
          contentText={<TXT name="msg_deleteOutfit" />}
          firstButtonText={<TXT name="btnModal_cancel" />}
          firstButtonFunc={this.handleModalClose}
          secondButtonText={<TXT name="btnModal_delete" />}
          secondButtonTextColor={colorCss.colorOfDanger}
          secondButtonFunc={this.handleOutfitDelete}
        />
        <DownloadImgModalView
          open={downloadModalOpen}
          onClose={this.handleModalClose}
          downloadImgInfo={downloadImgInfoObj}
        />
      </div>
    );
  }
}

export default withStore({
  dispatchMap: ["noticeModal"]
})(OptBtnForMyOutfitModalView);
